import React, { useState } from 'react'
import { CButton, CSpinner } from '@coreui/react-pro'
import { openScripture } from '../../helper/fusionHelper'
import GenericConfirmModal from './census/components/ConfirmationModals/GenericConfirmModal'

export default function ScriptsureBtn({ patientId, isButton = true }) {
  const [popupFailed, setPopupFailed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const onScriptureClick = async () => {
    if (isLoading) {
      return
    }
    setIsLoading(true)
    await openScripture(patientId, () => {
      setPopupFailed(true)
    })
    setIsLoading(false)
  }

  return (
    <>
      {isButton ? (
        <CButton color={'primary'} onClick={onScriptureClick} className={'ePrescribeBtn'}>
          {isLoading ? <CSpinner size={'sm'} /> : 'ePrescribe'}
        </CButton>
      ) : (
        <div onClick={onScriptureClick}>ePrescribe</div>
      )}
      {popupFailed && (
        <GenericConfirmModal
          onClose={() => {
            setPopupFailed(false)
          }}
          onConfirm={() => {
            setPopupFailed(false)
          }}
          title={'Failed to open ScriptSure'}
          content={
            'Your browser blocked the new tab. ScriptSure opens in a separate tab. Please allow pop-ups.'
          }
          confirmTxt={'Close'}
          showCancel={false}
          focus={false}
        />
      )}
    </>
  )
}
